import React from 'react';
import './Intro.css';

import CurvedBottom from '../CurvedBottom/CurvedBottom';

const intro = ( props ) => {
	
	return (
		<section id="Intro" className={ props.className }>
			{ props.children }
			<CurvedBottom />
		</section>
	);
	
};

export default intro;



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js